import { LABELS } from '@/constants/common/message.constants'

import { type ContractEntity } from '../..'

/**
 * 切り上げ or 切り捨ての種別
 */
export type RoundType = NonNullable<ContractEntity['overtimeRoundType']>

export const ROUND_TYPE = {
  /** 切り上げ */
  ROUND_UP: 'ROUND_UP',
  /** 切り捨て */
  ROUND_DOWN: 'ROUND_DOWN',
  /** 四捨五入 */
  ROUND_HALF_UP: 'ROUND_HALF_UP'
} as const satisfies Record<RoundType, RoundType>

export const ROUND_TYPE_LABEL = {
  [ROUND_TYPE.ROUND_UP]: LABELS.ROUND_UP, // 切り上げ
  [ROUND_TYPE.ROUND_DOWN]: LABELS.ROUND_DOWN, // 切り捨て
  [ROUND_TYPE.ROUND_HALF_UP]: LABELS.ROUND_HALF_UP // 四捨五入
} as const satisfies Record<RoundType, string>

/**
 * 端数処理 (roundType) プルダウンの選択肢。
 * 基本運賃・付帯費用の各入力 (配送依頼/配車板/運行実績) で共通利用する単一定義。
 * #4274: マスタデフォルトが切り捨て (#4249) になったため切り捨てを先頭にする。
 */
export const ROUND_TYPE_OPTIONS: { value: RoundType; label: string }[] = [
  {
    value: ROUND_TYPE.ROUND_DOWN,
    label: ROUND_TYPE_LABEL[ROUND_TYPE.ROUND_DOWN]
  },
  { value: ROUND_TYPE.ROUND_UP, label: ROUND_TYPE_LABEL[ROUND_TYPE.ROUND_UP] },
  {
    value: ROUND_TYPE.ROUND_HALF_UP,
    label: ROUND_TYPE_LABEL[ROUND_TYPE.ROUND_HALF_UP]
  }
]

/**
 * 税額の端数処理。BE `TaxService.applyRound`
 * (`logi-go-api/src/shared/modules/tax/tax.service.ts`) と同義。
 *
 * - `ROUND_DOWN`    : 切り捨て (`Math.floor`)
 * - `ROUND_HALF_UP` : 四捨五入 (`Math.round`)
 * - それ以外 (`ROUND_UP` / `null` / 未指定) : 切り上げ (`Math.ceil`、BE デフォルト)
 */
export const applyTaxRound = (
  raw: number,
  roundType?: RoundType | null
): number => {
  if (roundType === ROUND_TYPE.ROUND_DOWN) return Math.floor(raw)
  if (roundType === ROUND_TYPE.ROUND_HALF_UP) return Math.round(raw)
  return Math.ceil(raw)
}
